/* KillaArmy — light interactions */
(function () {
  const toggle = document.querySelector(".nav-toggle");
  const links = document.querySelector(".nav-links");
  if (toggle && links) {
    toggle.addEventListener("click", () => {
      const open = links.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  const panel = document.getElementById("familia-detail");
  const nodes = document.querySelectorAll("[data-familia]");
  if (panel && nodes.length) {
    const copy = {
      killabears: {
        title: "KillaBears — the root",
        body: "Our partners and the story world that started it all. Characters, Snapchat skins, and short films from Killabears.TV — plus a feature from Killaverse Entertainment (exec produced by Seth Green, production Thanksgiving 2026). Art lives here; killakush.com stays kid-safe.",
        links: [
          { href: "https://killabears.com", label: "killabears.com" },
          { href: "https://killabears.tv/", label: "killabears.tv" },
          { href: "/pages/films", label: "Watch films" }
        ],
      },
      killakush: {
        title: "Killa Kush — the product",
        body: "Premium cannabis fueling the culture. The product brand of the Familia. For adults 21+ only — kindness included free.",
        links: [{ href: "https://killakush.com", label: "killakush.com (21+)" }],
      },
      killaarmy: {
        title: "KillaArmy — the culture hub",
        body: "You're here. Community, creators, gamers, films, and media. Turning fans into a global tribe — armed with love. We rise as one.",
        links: [{ href: "/pages/join", label: "Join the Army" }],
      },
      plsy: {
        title: "PL$Y / Play Money — the lifestyle",
        body: "Streetwear, gaming, and skate culture. Burn money not friends. Lose the bag, run it back — loyalty is the real flex.",
        links: [{ href: "https://getplaymoney.com", label: "getplaymoney.com" }],
      },
      community: {
        title: "Community",
        body: "The heart of the flywheel. Loyalty, hype, and people who show up for each other with ridiculous abundance.",
        links: [{ href: "/pages/join", label: "Join the Army" }],
      },
      creators: {
        title: "Creators",
        body: "Voices that amplify the brand with playfulness and love. Real names only — no fabricated quotes.",
        links: [{ href: "/pages/culture", label: "Culture & Media" }],
      },
      gamers: {
        title: "Gamers & streaming",
        body: "Streaming culture that drives awareness. Part of the culture flywheel. Be kind in chat.",
        links: [{ href: "/pages/culture", label: "Culture & Media" }],
      },
      nugget: {
        title: "Nugget",
        body: "A tiny member of the Killa Familia — Cash's assistant, always around with kindness and a little chaos.",
        links: [],
      },
    };

    nodes.forEach((node) => {
      node.addEventListener("click", () => {
        nodes.forEach((n) => n.classList.remove("active"));
        node.classList.add("active");
        const key = node.getAttribute("data-familia");
        const data = copy[key];
        if (!data) return;
        let html = `<h3>${data.title}</h3><p>${data.body}</p>`;
        if (data.links && data.links.length) {
          html += `<div class="links">`;
          data.links.forEach((l) => {
            const ext = l.href.startsWith("http");
            html += `<a class="btn btn-secondary" href="${l.href}"${ext ? ' target="_blank" rel="noopener"' : ""}>${l.label}</a>`;
          });
          html += `</div>`;
        }
        panel.innerHTML = html;
        panel.classList.add("visible");
      });
    });
  }
})();
